import { ViewerTenantContextContainer } from "@workflows/ui";
import { useContext } from "react";
export function useAuth() {
  const {
    userId
  } = useContext(ViewerTenantContextContainer);
  return {
    isAuthenticated: userId != null
  };
}